export const GET_NAV_MENU_STATUS = "GET_NAV_MENU_STATUS";